import React, { useState, useEffect, useRef } from "react";
import useChromeExtensionListener from '../hooks/useChromeExtensionListener';
import useStore from '../hooks/useStore';
import { useTranslation } from 'react-i18next';
import { buildSalePayload, transformLoadedSaleEntries } from '../util/saleUtils';
import { useParams } from 'react-router-dom';
import { useForm, Controller, FormProvider } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import "react-datepicker/dist/react-datepicker.css";
import FormSelect from '../components/form-select'
import moment from 'moment-timezone';
import SaleEntriesGrid from "../components/aggrids/editable-aggrids/sale-entries-grid";
import Commons from '../util/commons'
import ApiClient from '../services/api-client';
import { useNavigate } from 'react-router-dom';
import BlockUi from '@availity/block-ui';
import { Loader } from 'react-loaders';
import SelectTable from '../components/select-table'
import { toast } from 'react-toastify';
import MoreTaxesGrid from '../components/aggrids/editable-aggrids/sale-more-taxes-grid';
import EntriesSummary from "../components/sales/entries.summary.component";
import PaymentMethodCard from "../components/sales/payment-method-card";
import TransportSection from "../components/sales/transport-section";
import InvoiceHeaderCard from "../components/sales/invoice-header-card";
import CustomerCard from "../components/sales/customer-card";
import SaleFooter from "../components/sales/sale-footer";
import { SaleFormContext } from "../components/sales/SaleFormContext";
import { createSaleValidationSchema } from "../components/sales/saleValidationSchema";
import { useSaleSubmit } from "../hooks/useSaleSubmit";
import loadSaleInstancesOptions from "../services/loaddata/loadSaleInstances";
import loadCustomersOptions from "../services/loaddata/loadCustomers";
import loadTaxOfficeOptions from "../services/loaddata/loadTaxOffices";
import loadCountriesOptions from "../services/loaddata/loadCountries.js";
import loadCurrenciesOptions from "../services/loaddata/loadCurrencies.js";
import FormLayout from '../components/layout/form-layout';
import IFramePrintTemplate from '../components/iframe-print-template.component';
import ReactFlagsSelect from "react-flags-select";
import Tippy from '@tippyjs/react';
import usePrintSaleBuilder from "../hooks/usePrintSaleBuilder.js";
import { useSaleViewData } from "../hooks/useSaleViewData";
import ErrorDetailsModal from "../components/modals/error-details-modal";
import { useSSEMessageHandler } from "../hooks/useSSEMessageHandler";
import useDisabledFields from "../hooks/useDisabledFields";
import useRequiredFields from "../hooks/useRequiredFields";
import useVisibility from "../hooks/useVisibility";
import PosLoader from '../components/sales/pos-loader';


const loadPageOptions = async (q, prevOptions, { page }, props) => {
    const { options, hasMore } = await loadSaleInstancesOptions(q, page, props);
    return {
        options,
        hasMore,
        additional: {
            page: page + 1
        }
    };
};
const loadCustomerPageOptions = async (q, prevOptions, { page }, props) => {
    const { options, hasMore } = await loadCustomersOptions(q, page, props);
    return {
        options,
        hasMore,
        additional: {
            page: page + 1
        }
    };
};
const loadTaxOfficePageOptions = async (q, prevOptions, { page }, props) => {
    const { options, hasMore } = await loadTaxOfficeOptions(q, page, props);
    return {
        options,
        hasMore,
        additional: {
            page: page + 1
        }
    };
};

const loadCountriesPageOptions = async (q, prevOptions, { page }, props) => {
    const { options, hasMore } = await loadCountriesOptions(q, page, props);
    return {
        options,
        hasMore,
        additional: {
            page: page + 1
        }
    };
};


const loadCurrenciesPageOptions = async (q, prevOptions, { page }, props) => {
    const { options, hasMore } = await loadCurrenciesOptions(q, page, props);
    return {
        options,
        hasMore,
        additional: {
            page: page + 1
        }
    };
};



const SalesAddEdit = (props) => {
    const { id } = useParams();
    const navigate = useNavigate();
    const refErrorDetailsModal = useRef();
    const saleMoreTaxesGridRef = useRef();
    const refEntriesSummary = useRef();
    const iframePrintTemplate = useRef();
    const refSalesEntries = useRef();
    const customerCardRef = useRef();

    const showErrorDetailsModal = (error) => {
        refErrorDetailsModal.current.open(error);
    }

    const scrollInnerContainer = (options) => {
        const el = document.querySelector(".innerContainerMain");
        if (el) el.scrollTo(options);
    };

    const [content, setContent] = useState({ customers: { data: [], columns: [] } });
    const [customerContacts, setCustomerContacts] = useState({ data: [], columns: [] });
    const [salesLeft, setSalesLeft] = useState(0);
    const { t } = useTranslation();

    const ATHENS_TIMEZONE = "Europe/Athens";
    const toPickerDate = (athensMoment) => new Date(
        athensMoment.year(),
        athensMoment.month(),
        athensMoment.date(),
        athensMoment.hour(),
        athensMoment.minute(),
        0
    );

    const [startDate, setStartDate] = useState(
        toPickerDate(moment.tz(ATHENS_TIMEZONE))
    );

    const [dispatchDate, setDispatchDate] = useState(
        moment.tz(ATHENS_TIMEZONE).toDate()
    );

    const dispatchStartDate = moment.tz(ATHENS_TIMEZONE).toDate();

    const { buildPrintSale } = usePrintSaleBuilder();

    const [mydata, setMyData] = useState(false);
    const [editMark, setEditMark] = useState("");
    const [blockuiLoading, setBlockuiLoading] = useState(false);
    const [suggestedInClassCatsOfInvType, setSuggestedInClassCatsOfInvType] = useState([]);
    const [suggestedInvoiceClassCatsOfInvType, setSuggestedInvoiceClassCatsOfInvType] = useState([]);
    const [selectedContacts, setSelectedContacts] = useState([]);
    const [selfPricingChecked, setSelfPricingChecked] = useState(false);
    const [inputCustomerValue, setCustomerInputValue] = useState("");
    const [customerValue, setCustomerValue] = useState("");
    const [taxOfficeValue, setTaxOfficeValue] = useState("");
    const [countryValue, setCountryValue] = useState("");
    const [moreTaxesTypesOptions, setMoreTaxesTypesOptions] = useState([]);
    const [DefaultCountry, setDefaultCountry] = useState({value:'GR', label:t('GR')});
    const [selectedMyDataInvoiceType, setSelectedMyDataInvoiceType] = useState(null);
    const [isDeliverMandatory, setIsDeliverMandatory] = useState(false);
    const [isLoadingMandatory, setIsLoadingMandatory] = useState(false);
    const [mark, setMark] = useState(null);
    const [transportInfoDisplay, setTransportInfoDisplay] = useState("none");
    const [entriesHidden, setEntriesHidden] = useState("none");
    const [otherTaxHidden, setOtherTaxHidden] = useState("none");
    const [otherTaxRequired, setOtherRequired] = useState(false);
    const [template, setTemplate] = useState(false);
    const [isInvoice00_1, setIsInvoice00_1] = useState(false);
    const [sosMessage, setSosMessage] = useState(false);
    const [moreTaxesOptions, setMoreTaxesOptions] = useState([]);
    const [showSecondPayment, setShowSecondPayment] = useState(false);
    const [otherTaxesOptions, setOtherTaxesOptions] = useState([]);
    const [initiallyCollapsed, setInitiallyCollapsed] = useState({ collapsed: true, show: true });
    const [initiallyCollapsedDeliveryMore, setInitiallyCollapsedDeliveryMore] = useState({ collapsed: true, show: false });
    const [dismissSalesEditAlert, setDismissSalesEditAlert] = useState(false);
    const [sendPaymentLink, setSendPaymentLink] = useState(false);
    const [selectedTemplateLanguage, setSelectedTemplateLanguage] = useState("GR");

    useSSEMessageHandler();

    const { makeFieldRequired, makeFieldOptional, toggleFieldRequired, isFieldRequired } = useRequiredFields({ customer: true, taxpayerId: true, paymentMethod1: false, country: true });
    const { disableField, enableField, toggleField, isFieldDisabled } = useDisabledFields();
    const CUSTOMER_FIELDS = ["customer", "taxpayerId", "country", "city", "fulladdress", "addressNumber", "postalCode", "taxOffice", "subjectField"];
    const disableCustomerFields = () => CUSTOMER_FIELDS.forEach(f => disableField(f));
    const enableCustomerFields = () => CUSTOMER_FIELDS.forEach(f => enableField(f));
    const { show, hide, toggle: toggleVisibility, isVisible } = useVisibility({
        correlativeSales: false,
        selfPricing: false,
        balance_container: false,
        saveCustomerForFuture: false,
        transformDataCard: true,
        taxesMoreAccordion: true,
        salesMoreAccordion: true,
        documentTypeInfo: false,
        afterinvoice: false,
    });
    const [documentTypeInfoMessage, setDocumentTypeInfoMessage] = useState("");

    const selectedCompany = useStore(state => state.selectedCompany);
    const setSelectedCompany = useStore(state => state.setSelectedCompany);
    const loggedInUser = useStore(state => state.loggedInUser);
    moment.tz.setDefault(ATHENS_TIMEZONE);

    const [totals, setTotals] = useState({
        totalWithoutDiscount: "0.00",
        totalWithDiscount: "0.00",
        totalWithoutVat: "0.00",
        totalWithVat: "0.00",
        totalPayment: "0.00",
        totalvat: "0.00"
    });

    const params = new URLSearchParams(window.location.search);
    let customer = params.get('customer');
    let isCredit = params.get('credit');
    let isPreSale = params.get('presale');

    isCredit = isCredit == "true" ? true : false;
    isPreSale = isPreSale == "true" ? true : false;

    const { saleViewData } = useSaleViewData(selectedCompany.id);

    const validationSchema = createSaleValidationSchema({
        showSecondPayment,
        totalPayment: totals.totalPayment,
        isFieldRequired,
        isDeliverMandatory,
        isLoadingMandatory,
        otherTaxRequired,
        t,
    });

    const methods = useForm({
        resolver: yupResolver(validationSchema)
    });
    const { register, getValues, control, handleSubmit, setValue, reset, formState: { errors }, trigger, clearErrors, watch } = methods;
    const watchPaymentType = watch('paymentType');
    const watchPaymentType2 = watch('paymentType2');
    const isPosPayment = watchPaymentType?.value === 'POS' || watchPaymentType2?.value === 'POS';

    const { onSubmit: _onSubmit, onSubmitDraft, onError, handlePrint, handlePrintAndSave } = useSaleSubmit({
        getValues, refSalesEntries, saleMoreTaxesGridRef, iframePrintTemplate, customerCardRef,
        mydata, totals, template, setBlockuiLoading, scrollInnerContainer, afterPrintProcess,
        showErrorDetailsModal, buildPrintSale, prepareSale, t, SELECTED_COMPANY: selectedCompany,
    });
    const onSubmit = (data, e) => {
        if (isFieldRequired("paymentMethod1") && !data.paymentType) {
            e?.preventDefault();
            toast.error(t("paymentMethodRequired"));
            return;
        }
        _onSubmit(data, e);
    };

    useEffect(() => {
        if (!selectedCompany?.id) return;
        ApiClient.getCompany(selectedCompany.id).then(response => {
            setSelectedCompany(response.data);
            localStorage.setItem("company", JSON.stringify(response.data));
        }).catch(() => { });
    }, [selectedCompany?.id]);

    useEffect(() => {
        if (!saleViewData) return;

        const companyId = selectedCompany.id;
        const defaults = Commons.getDefaults();

        if (defaults != undefined && defaults.mydata != undefined) {
            setMyData(defaults.mydata)
        }
        else {
            setMyData(!!selectedCompany.myDataToken)
        }

        if (defaults) {
            setDismissSalesEditAlert(defaults.dismissSalesEditAlert)
        }

        if (defaults.branch && defaults.branch.value && !isCredit) {
            loadTemplate(companyId, defaults.branch.value);
        }

        if (saleViewData.sosMessage) setSosMessage(saleViewData.sosMessage);
        setSalesLeft(saleViewData.salesLeft);
        setMoreTaxesOptions(saleViewData.moreTaxesOptions);
        setMoreTaxesTypesOptions(saleViewData.moreTaxesTypesOptions);
        setOtherTaxesOptions(saleViewData.otherTaxesOptions);
        setContent(saleViewData.content);


        if (id != undefined) {
            if (!isPreSale && mark != null) {
                disableField("taxpayerId");
                disableField("branch");
                disableField("invoiceType");
                disableField("invoiceDate");
                disableField("series");
                disableField("customer");
            }

            ApiClient.getCompanySaleInstance(companyId, id).then(
                response => {
                    var sale = response.data;
                    console.log(sale)

                    var _invoiceType = {
                        label: sale.invoiceTypeName,
                        value: sale.invoiceTypeId,
                        myDataInvoiceType: sale.myDataInvoiceType
                    }

                    sale.invoiceType = _invoiceType
                    if (!isCredit) {
                        if (sale.mark) {
                            var markInfo =
                                <div>
                                    <div>{t("currentMarkInfo") + ": " + sale.mark + ". "}</div>

                                    {dismissSalesEditAlert ?
                                        <>
                                            <div className="alert alert-warning alert-dismissible fade show" id="dismissSalesEditAlert" role="alert" style={{ padding: 10 }}>
                                                <div><small> {t("currentMarkInfo2")}</small></div>
                                                <button type="button" style={{ padding: 8 }} className="btn-close" onClick={dismissSalesEditAlertHandle} data-bs-dismiss="alert" aria-label="Close"></button>
                                            </div></> : <></>
                                    }

                                </div>
                            setEditMark(markInfo);
                        }
                    }

                    var branch = { label: sale.branchName, value: sale.branchId, model: { id: sale.branchId, branchNumber: sale.branchNumber, address: sale.branchAddress, name: sale.branchName }, invoiceTypeId: sale.invoiceTypeId }

                    changeBranch(branch);
                    setValue("branch", branch);

                    sale.invoiceType.branchId = sale.branchId;
                    changeInvType(sale.invoiceType);

                    if (!isCredit && !isPreSale) {
                        setValue("invoiceType", sale.invoiceType);
                        var _ser = { value: sale.series, label: sale.series };
                        sale.series = _ser;

                        setValue("series", sale.series);
                        setValue("invoiceNumber", sale.invoiceNumber);
                    }
                    else {

                        if (sale.invoiceType.myDataInvoiceType == "invoice1_1" || sale.invoiceType.myDataInvoiceType == "invoice2_1" || sale.invoiceType.myDataInvoiceType == "invoice1_2" || sale.invoiceType.myDataInvoiceType == "invoice1_3") {
                            var _invtype = {
                                label: t("invoice5_1"),
                                value: 999999,
                                myDataInvoiceType: "invoice5_1"
                            }
                            setValue("invoiceType", _invtype);
                            show('correlativeSales');
                            sale.correlativeSales = {
                                label: sale.mark,
                                value: sale.id,
                                mark: sale.mark,
                            }
                            setValue("correlativeSales", sale.correlativeSales);
                        }
                    }

                    var asExpenses = getValues().selfPricing || Commons.isOnGroup(sale.invoiceType.myDataInvoiceType, "isExpense");

                    ApiClient.getClassificationCategoriesOfMyDataInvoice(sale.invoiceType.myDataInvoiceType, asExpenses).then(response => {
                        var data = response.data;
                        var obj = {}
                        data.forEach(element => {
                            obj[element.classificationCategory] = element.classificationValues;
                        });
                        setDataWithClassifications(sale, obj, saleViewData.myDataMoreTaxesOptions)
                    },
                        error => {
                            console.error(
                                (error.response &&
                                    error.response.data &&
                                    error.response.data.message) ||
                                error.message ||
                                error.toString())
                        }
                    );


                    var customer = { label: sale.customerName, value: sale.customerName, model: sale.customer }
                    var city = sale.customerCity;
                    var address = sale.customerAddress;
                    var postalCode = sale.customerPostalCode;
                    var taxpayerId = sale.customerTaxPayerId;
                    var addressNumber = sale.customerAddressNumber;
                    var subjectField = sale.subjectField;
                    var branch = { label: sale.branchName, value: sale.branchId, model: { id: sale.branchId, branchNumber: sale.branchNumber, address: sale.branchAddress, name: sale.branchName } }

                    var paymentType = { label: t(sale.paymentType), value: sale.paymentType }



                    if (sale.saleInstanceMoreTaxes && sale.saleInstanceMoreTaxes.length > 0) {
                        var _data_transformed = saleMoreTaxesGridRef.current.transformData(sale.saleInstanceMoreTaxes, saleViewData.moreTaxesTypesOptions, saleViewData.myDataMoreTaxesOptions)
                        saleMoreTaxesGridRef.current.setData(_data_transformed);
                        setInitiallyCollapsed({ collapsed: false, show: true });
                    }


                    setTimeout(function () {
                        if (taxpayerId) {
                            setValue("taxpayerId", taxpayerId);
                        }
                        if (customer) {
                            setValue("customer", customer);
                            setCustomerValue(customer);
                        }


                        if (address) {
                            setValue("fulladdress", address);
                        }
                        setValue("addressNumber", addressNumber);
                        setValue("subjectField", subjectField)
                        setValue("city", city);
                        setValue("postalCode", sale.customerPostalCode);
                        if (sale.taxOffice) {
                            setValue("taxOffice", { label: sale.taxOffice.name, value: sale.taxOffice.id });
                            setTaxOfficeValue({ label: sale.taxOffice.name, value: sale.taxOffice.id })
                        }

                        setValue("notes", sale.notes);


                        setValue("isDeliveryNote", sale.isDeliveryNote);

                        if (sale.movePurpose) {
                            setValue("movePurpose", {
                                label: t(sale.movePurpose),
                                value: sale.movePurpose
                            });

                            setValue("otherMovePurposeTitle", sale.otherMovePurposeTitle);
                        }

                        if (sale.dispatchDate) {


                            const _dispatchDate = moment.tz(
                                moment(sale.dispatchDate).format()
                            );
                            setValue("dispatchDate", _dispatchDate.toDate());
                            setDispatchDate(_dispatchDate);
                        }

                        if (sale.isDeliveryNote) {
                            setInitiallyCollapsedDeliveryMore({ collapsed: true, show: true })
                            setIsDeliverMandatory(true)
                            setIsLoadingMandatory(true)
                        }

                        setValue("country", { label: t(sale.customerCountry.alpha2), value: sale.customerCountry.alpha2 });



                        setValue("vehicleNumber", sale.vehicleNumber);
                        setValue("exchangeRate", sale.exchangeRate);

                        setValue("loadingAddressStreet", sale.loadingAddressStreet);
                        setValue("loadingAddressNumber", sale.loadingAddressNumber);
                        setValue("loadingAddressCity", sale.loadingAddressCity);
                        setValue("loadingAddressPostalCode", sale.loadingAddressPostalCode);

                        setValue("deliveryAddressStreet", sale.deliveryAddressStreet);
                        setValue("deliveryAddressNumber", sale.deliveryAddressNumber);
                        setValue("deliveryAddressCity", sale.deliveryAddressCity);
                        setValue("deliveryAddressPostalCode", sale.deliveryAddressPostalCode);


                        if (sale.currency) {
                            setValue("currency", {
                                label: sale.currency,
                                value: sale.currency
                            });
                        }

                        if (!isCredit) {
                            const athensDateTime = moment.tz(
                                moment(sale.invoiceDate, ['DD/MM/YYYY HH:mm:ssZ', 'DD/MM/YYYY', moment.ISO_8601]).format("YYYY-MM-DD HH:mm"),
                                "YYYY-MM-DD HH:mm",
                                ATHENS_TIMEZONE
                            );
                            const pickerDate = toPickerDate(athensDateTime);
                            setStartDate(pickerDate);
                            setValue("invoiceDate", athensDateTime.toDate());


                            setMark(sale.mark)
                        }
                        else {
                            setValue("invoiceDate", moment.tz(ATHENS_TIMEZONE).toDate());
                        }

                        if (sale.customer && sale.customer.country) {
                            setValue("country", { label: t(sale.customer.country.alpha2), value: sale.customer.country.alpha2 });
                        }

                        if (sale.paymentMethods && sale.paymentMethods.length > 0) {
                            if (sale.paymentMethods[0]) {
                                setValue("paymentType", { value: sale.paymentMethods[0].paymentType, label: t(sale.paymentMethods[0].paymentType), model: sale.paymentMethods[0] });
                                setValue("paymentAmount", parseFloat(sale.paymentMethods[0].paymentAmount).toFixed(2));
                                if (sale.paymentMethods[0].paymentType === "ON_CREDIT") {
                                    enableField("preloadTransaction");
                                    enableField("preloadExpiration");
                                } else {
                                    disableField("preloadTransaction");
                                    disableField("preloadExpiration");
                                }
                                if (sale.paymentMethods[0].transactionId) {
                                    disableField("paymentType")
                                    disableField("paymentAmount")
                                }
                            }

                            if (sale.paymentMethods[1]) {
                                setShowSecondPayment(true);
                                setValue("paymentType2", { value: sale.paymentMethods[1].paymentType, label: t(sale.paymentMethods[1].paymentType), model: sale.paymentMethods[1] });
                                setValue("paymentAmount2", sale.paymentMethods[1].paymentAmount);
                                if (sale.paymentMethods[1].paymentType === "ON_CREDIT") {
                                    enableField("preloadTransaction2");
                                    enableField("preloadExpiration2");
                                } else {
                                    disableField("preloadTransaction2");
                                    disableField("preloadExpiration2");
                                }
                                if (sale.paymentMethods[1].transactionId) {
                                    disableField("paymentType2")
                                    disableField("paymentAmount2")
                                }
                            }
                        }

                    }, 100)

                },
                error => {
                    setBlockuiLoading(false)
                    toast.error("Error: " + error.response.data.message)
                    console.error(error.response.data)
                }
            )

        }
        else {
            setValue("paymentType", convertPaymentType({ value: "CASH", label: t("CASH") }))
            setValue("invoiceDate", moment.tz(ATHENS_TIMEZONE).toDate());

            if (defaults != undefined && defaults.notes != undefined) {
                setValue("notes", defaults.notes)
            }

            if (defaults.paymentType) {
                setValue("paymentType", defaults.paymentType);
                if (defaults.paymentType.value == "ON_CREDIT") {
                    show('balance_container');
                    enableField("preloadTransaction");
                    enableField("preloadExpiration");
                }
                else {
                    hide('balance_container');
                    disableField("preloadTransaction");
                    disableField("preloadExpiration");
                }
            }

            if (defaults.templateLang) {
                setValue("templateLang", defaults.templateLang);
                setSelectedTemplateLanguage(defaults.templateLang.toUpperCase())
            }


            if (defaults.branch != undefined) {
                setValue("branch", defaults.branch);
            }
            else {
                if (saleViewData.content.optionBranches.length == 1) {
                    var _branch = saleViewData.content.optionBranches[0];
                    setValue("branch", _branch);
                    Commons.setDefault("branch", _branch)
                    if (_branch) {
                        loadTemplate(companyId, _branch.value);
                    }
                }
            }


            if (defaults.invoiceType != undefined) {
                changeInvType(defaults.invoiceType);
                setValue("invoiceType", defaults.invoiceType);

            }
            else {
                if (saleViewData.content.optionsinvoiceTypes.length == 1) {
                    changeInvType(saleViewData.content.optionsinvoiceTypes[0]);
                    setValue("invoiceType", saleViewData.content.optionsinvoiceTypes[0]);
                }
                else {
                    setBlockuiLoading(false)
                }
            }
        }


    }, [saleViewData]);


    function loadTemplate(companyId, branchId) {
        ApiClient.getTemplateSettings(companyId, branchId).then(response => {
            var _template = response.data;
            _template.branch = branchId;
            _template.mainColor = _template.mainColor ? _template.mainColor : "#013289";
            _template.secondaryColor = _template.secondaryColor ? _template.secondaryColor : "#FFFFFF";
            _template.appFont = _template.appFont ? _template.appFont : "Arial";
            setTemplate(_template);
        }, error => {
            setBlockuiLoading(false)
            console.error(
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString())
        });
    }

    function afterPrintProcess(sale) {
        setTimeout(function () {
            if (selectedContacts.length > 0) {
                show('template');
                setBlockuiLoading(false)
            }
            else {
                setBlockuiLoading(false);
            }

            const currentValues = getValues();

            setCustomerValue(null)
            setDispatchDate(moment.tz(ATHENS_TIMEZONE).format("YYYY-MM-DD HH:mm"));

            setTaxOfficeValue(null)

            setValue("paymentAmount", null)
            setValue("currency", null);
            setValue("exchangeRate", null);
            setValue("dispatchDate", null)

            var invoiceNumber = currentValues.invoiceNumber;

            reset({
                ...currentValues,
                invoiceNumber: invoiceNumber + 1,
                customer: null,
                taxpayerId: null,
                country: null,
                city: null,
                fulladdress: null,
                addressNumber: null,
                postalCode: null,
                taxOffice: null,
                movePurpose: null,
                vehicleNumber: null,
                loadingAddressStreet: null,
                loadingAddressNumber: null,
                deliveryAddressStreet: null,
                deliveryAddressNumber: null,
                loadingAddressPostalCode: null,
                deliveryAddressPostalCode: null,
                loadingAddressCity: null,
                deliveryAddressCity: null,
                subjectField: null
            });
            if (refSalesEntries.current) {
                refSalesEntries.current.clearData();
                saleMoreTaxesGridRef.current.clearData();
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }

        }, 2000)
    }

    function prepareSale(_sale) {
        return buildSalePayload(_sale, {
            entries: refSalesEntries.current.getData().entries,
            moreTaxes: saleMoreTaxesGridRef.current.getData(),
            mark,
            saleId: id,
            isCredit,
            suggestedInClassCatsOfInvType,
            totals,
            company: selectedCompany,
            userEmail: loggedInUser.email,
            contacts: selectedContacts,
            sendPaymentLink,
            t,
        });
    }

    function changeCust(val) {
        setValue("customer", val)
        const athensNow = moment.tz(
            [startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), startDate.getHours(), startDate.getMinutes()],
            ATHENS_TIMEZONE
        );
        setValue("invoiceDate", athensNow.toDate());
        setCustomerValue(val)

        var _contacts = [];
        if (val.model) {
            var contacts = val.model.contacts;
            if (contacts) {
                contacts.forEach(e => {
                    _contacts.push({
                        value: e.email,
                        name: e.name,
                        email: e.email,
                        label: e.email
                    })
                });



                if (selectedCompany.accountantEmail) {
                    _contacts.push({
                        value: selectedCompany.accountantEmail,
                        name: t("companyAccountant"),
                        email: selectedCompany.accountantEmail,
                        label: selectedCompany.accountantEmail
                    })
                }

                var opts = {
                    data: _contacts, columns: [
                        {
                            header: t("Name"),
                            field: "name",
                            flex: 6,
                        },
                        {
                            header: t("Email"),
                            field: "email",
                            flex: 6,
                            asLabel: true
                        }
                    ]
                }
                setCustomerContacts(opts)
            }
            var selectedMyDataInvType = getValues().invoiceType.myDataInvoiceType;
            var isDeliveryNote = getValues().isDeliveryNote;

            if (Commons.isOnGroup(selectedMyDataInvType, "zeroCustomerTaxpayerId")) {
                setValue("taxpayerId", "000000000");
            }
            else {
                setValue("taxpayerId", val.model.taxpayerId);
            }


            setValue("fulladdress", val.model.address);
            setValue("postalCode", val.model.postalCode);
            setValue("addressNumber", val.model.number);
            setValue("city", val.model.city);
            setValue("subjectField", val.model.subjectField);

            if (val.model.country != null && !Commons.isOnGroup(selectedMyDataInvType, "countryDisable")) {
                setValue("country", { value: val.model.country.alpha2, label: t(val.model.country.alpha2) })
            }

            if (val.model.taxOffice) {
                setValue("taxOffice", { label: val.model.taxOffice.name, value: val.model.taxOffice.id });
                setTaxOfficeValue({ label: val.model.taxOffice.name, value: val.model.taxOffice.id });
            }


            if (selectedMyDataInvType == "invoice2_01" || selectedMyDataInvType == "invoice11_02") {
                setValue("recipientTaxPayerId", val.model.taxpayerId);
                setValue("recipientName", val.model.name);
                setValue("senderTaxPayerId", val.model.taxpayerId);
                setValue("senderName", val.model.name);
            }
            else if (selectedMyDataInvType == "invoice9_3" || isDeliveryNote) {
                setValue("deliveryAddressNumber", val.model.number);
                setValue("deliveryAddressStreet", val.model.address);
                setValue("deliveryAddressCity", val.model.city);
                setValue("deliveryAddressPostalCode", val.model.postalCode);
                var branch = getValues().branch;
                setValue("loadingAddressStreet", branch.model.address);
            }



            clearErrors("customer");
            clearErrors("taxpayerId");
            clearErrors("country");
            clearErrors("city");
            clearErrors("fulladdress");
            clearErrors("postalCode");
        }
    }

    function setDataWithClassifications(saleObject, optionIncClassCategories, myDataMoreTaxesOptions, isPreSale = false) {
        const { entries, formUpdates } = transformLoadedSaleEntries(saleObject, optionIncClassCategories, myDataMoreTaxesOptions, {
            isPreSale,
            selfPricing: getValues().selfPricing,
            invoiceType: getValues().invoiceType,
            currentInvoiceTypeMyData: getValues().invoiceType?.myDataInvoiceType,
            t,
        });
        refSalesEntries.current.setData(entries);
        formUpdates.forEach(([field, value]) => setValue(field, value));
        reCalculateTotals();
    }

    function appendAccountantEmailOnContactsSelect() {
        var _contacts = [];
        if (selectedCompany.accountantEmail) {
            _contacts.push({
                value: selectedCompany.accountantEmail,
                name: t("companyAccountant"),
                email: selectedCompany.accountantEmail,
                label: selectedCompany.accountantEmail
            })
        }

        var opts = {
            data: _contacts, columns: [
                {
                    header: t("Name"),
                    field: "name",
                    flex: 6,
                },
                {
                    header: t("Email"),
                    field: "email",
                    flex: 6,
                    asLabel: true
                }
            ]
        }
        setCustomerContacts(opts)
    }

    const onInputChangeCustomer = (val, action) => {
        if (action.action != "input-blur" && action.action != "menu-close") {
            setValue("customer", { label: val, value: val });
            setCustomerInputValue(val)
            show('saveCustomerForFuture');
            // setCustomerValue({ label: val, value: val })

        }
        else if (action.action == "menu-close") {
            // var _country = getValues()["country"];
            // if (_country == undefined || _country == "") {
            //     var selectedMyDataInvType = getValues().invoiceType.myDataInvoiceType;
            //     if (selectedMyDataInvType != "invoice1_3") {
            //         setValue("country", DefaultCountry)
            //     }

            // }
        }
    };

    const onChangeCustomer = val => {
        // var _val=val;
        if (val.__isNew__) {
            show('saveCustomerForFuture');
        }
        else {
            hide('saveCustomerForFuture');
        }
        changeCust(val)
    };

    const onPaymentAmountChange = e => {
        trigger("paymentAmount");
        var newprice = e.target.value;
        if (newprice) {
            newprice = newprice.replace(",", ".");
            setValue("paymentAmount", parseFloat(newprice).toFixed(2))
        }
    }

    const onPaymentAmount2Change = e => {
        trigger("paymentAmount2");
        var newprice = e.target.value;
        if (newprice) {
            newprice = newprice.replace(",", ".");
            setValue("paymentAmount2", parseFloat(newprice).toFixed(2))
        }
    }

    const onUpdateComplete = (data) => {
        setTotals(data);
        setValue("paymentAmount", data.totalPayment);
    };

    const onChangePaymentType = val => {
        if (val != null && val.value == "ON_CREDIT") {
            show('balance_container');
            enableField("preloadTransaction");
            enableField("preloadExpiration");
        }
        else {
            hide('balance_container');
            disableField("preloadTransaction");
            disableField("preloadExpiration");
        }
        setValue("paymentType", val);
        Commons.setDefault("paymentType", val);
    };

    const onChangePaymentType2 = val => {
        if (val != null && val.value == "ON_CREDIT") {
            show('balance_container');
            enableField("preloadTransaction2");
            enableField("preloadExpiration2");
        }
        else {
            hide('balance_container');
            disableField("preloadTransaction2");
            disableField("preloadExpiration2");
        }
        setValue("paymentType2", val);
        Commons.setDefault("paymentType2", val);
    };

    function changeSeries(val) {
        var companyId = selectedCompany.id
        var branch = getValues().branch;
        var invType = getValues().invoiceType;
        var branchName, invTypeName;
        if (branch) {
            branchName = branch.label;
        }
        if (invType) {
            invTypeName = invType.label;
        }
        var series = val ? val.label : "";

        var invoiceNumberIdentifierDTO = {
            branchNumber: branch.model.branchNumber,
            branchId: branch.model.id,
            invoiceTypeId: invType.value,
            myDataInvoiceType: invType.myDataInvoiceType,
            series: series
        }

        ApiClient.getMaxCompanySaleInstanceNumber(invoiceNumberIdentifierDTO, companyId).then(
            response => {
                if (response) {
                    setValue("invoiceNumber", response.data)
                }
                else {
                    setValue("invoiceNumber", 1)
                }
                clearErrors("series");
                clearErrors("invoiceNumber");

            },
            error => {
                toast.error("Error: " + error.data)
                console.error(error.data)
            }
        );
    }

    const onChangeSelfPricing = e => {
        var val = e.target.checked;
        setSelfPricingChecked(val);
        var invoiceType = getValues().invoiceType;
        var asExpenses = Commons.isOnGroup(invoiceType.myDataInvoiceType, "isExpense") || val;

        if (id == undefined) {
            ApiClient.getClassificationCategoriesOfMyDataInvoice(invoiceType.myDataInvoiceType, asExpenses).then(response => {
                var data = response.data;
                var _optionIncClassCategories = [];
                data.forEach(element => {
                    var _classificationCategoryType;
                    var _classificationValueTypes;
                    _classificationCategoryType = element.classificationCategory;
                    _classificationValueTypes = element.classificationValues;

                    var prefix = _classificationCategoryType.replace("CATEGORY_", "") + ") ";
                    _optionIncClassCategories.push({
                        value: _classificationCategoryType,
                        label: prefix + t(_classificationCategoryType),
                        classificationValues: _classificationValueTypes,
                    });
                });
                setSuggestedInClassCatsOfInvType(_optionIncClassCategories);
            },
                error => {
                    console.error(
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString())
                }
            );
            refSalesEntries.current.clearData();
        }
    }

    const onChangeSeries = val => {
        setValue("series", val);
        Commons.setDefault("series", val);
        changeSeries(val)
    };

    const onChangeBranch = val => {
        setValue("branch", val);
        changeBranch(val);
    };

    const onChangeMovePurpose = val => {
        setValue("movePurpose", val);
        clearErrors("movePurpose");
        if (val && val.value == "PURPOSE_19") {
            makeFieldRequired("otherMovePurposeTitle");
        }
        else {
            makeFieldOptional("otherMovePurposeTitle");
        }
    };

    const taxOfficeOnChange = val => {
        setValue("taxOffice", val);
        setTaxOfficeValue(val);
    };

    const countryOnChange = val => {
        clearErrors("country");
        setValue("country", val);
        setCountryValue(val);
    };

    const isDeliveryNoteChange = e => {
        setInitiallyCollapsedDeliveryMore({ collapsed: e.target.checked, show: e.target.checked })

        if (e.target.checked) {
            setIsDeliverMandatory(true);
            setIsLoadingMandatory(true);
            makeFieldRequired("fulladdress");
            makeFieldRequired("postalCode");
            makeFieldRequired("city");
            makeFieldRequired("addressNumber");

            var addressNumber = getValues().addressNumber;
            var city = getValues().city;
            var fulladdress = getValues().fulladdress;
            var postalCode = getValues().postalCode;
            var branch = getValues().branch;


            if (branch != null) {
                setValue("loadingAddressStreet", branch.model.address);
            }
            if (fulladdress != null) {
                setValue("deliveryAddressStreet", fulladdress);
            }
            if (addressNumber != null) {
                setValue("deliveryAddressNumber", addressNumber);
            }
            if (city != null) {
                setValue("deliveryAddressNumber", city);
            }
            if (postalCode != null) {
                setValue("deliveryAddressNumber", postalCode);
            }

        }
        else {
            setIsDeliverMandatory(false);
            setIsLoadingMandatory(false);
            makeFieldOptional("fulladdress");
            makeFieldOptional("postalCode");
            makeFieldOptional("city");
            makeFieldOptional("addressNumber");

            setValue("loadingAddressStreet", null);
            setValue("deliveryAddressStreet", null);
            setValue("deliveryAddressNumber", null);
            setValue("deliveryAddressNumber", null);
            setValue("deliveryAddressNumber", null);
        }

    };

    function changeBranch(val) {
        if (!isCredit && id == null) {
            Commons.setDefault("branch", val)
        }

        clearErrors("branch");
        setValue("series", "")
        setValue("invoiceNumber", "")
        var selectedInvType = getValues().invoiceType;
        var invoiceTypeId = selectedInvType != "" ? selectedInvType.value : val.invoiceTypeId;
        var branchId = val.model ? val.model.id : val.value;

        if (selectedInvType) {
            ApiClient.getCompanyInvoiceTypeSeries(selectedCompany.id, invoiceTypeId, branchId, isCredit).then(response => {
                var data = response.data;
                var optionSeries = [];
                if (data) {
                    data.forEach(element => {
                        optionSeries.push({
                            value: element.id,
                            startNumber: element.startNumber,
                            label: element.name,
                        });
                    });
                }


                setContent(content => ({
                    ...content,
                    ...{ series: optionSeries }
                }));

            },
                error => {
                    setBlockuiLoading(false)
                    console.error(
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString())
                }
            );
        }

        loadTemplate(selectedCompany.id, branchId);
    }

    function clearAllMandatoryStarts() {
        setIsDeliverMandatory(false);
        setIsLoadingMandatory(false);
    }

    function changeInvType(val) {
        const mdit = val.myDataInvoiceType;
        setSelectedMyDataInvoiceType(mdit);
        const isInvoice9x = ["invoice9_1", "invoice9_2", "invoice9_3"].includes(mdit);
        const isAccom = mdit === "invoice8_2";
        const isCustomerForbidden = Commons.isOnGroup(mdit, "customerForbidden");
        const isZeroCustomerTIN = Commons.isOnGroup(mdit, "zeroCustomerTaxpayerId");
        const isZeroPrice = Commons.isOnGroup(mdit, "zeroPrice");
        const isDeliveryNoteType = Commons.isOnGroup(mdit, "isDeliveryNote");
        const isDeliveryNoteChecked = getValues().isDeliveryNote;

        // — resets —
        clearAllMandatoryStarts();
        setValue("connectedSales", null);
        setValue("correlativeSales", null);
        hide('correlativeSales');
        hide('selfPricing');

        // — clear country and address on invoice type change —
        setValue("country", null);
        setCountryValue(null);
        clearErrors("country");
        setValue("fulladdress", null);
        setValue("addressNumber", null);
        setValue("city", null);
        setValue("postalCode", null);

        // — info message per invoice type —
        var defaults = Commons.getDefaults();
        var infos = defaults.invoiceTypeMessages;
        hide('documentTypeInfo');
        setDocumentTypeInfoMessage("");
        if (infos) {
            var index = infos.indexOf(mdit);
            if (infos[index]) {
                show('documentTypeInfo');
                setDocumentTypeInfoMessage(t(infos[index] + "_info"));
            }
        }

        var companyId = selectedCompany.id;
        var invoiceTypeId = val.value;
        clearErrors("taxpayerId");
        clearErrors("customer");

        // — customer / taxpayerId —
        enableCustomerFields();

        if (isCustomerForbidden) {
            makeFieldOptional("customer");
            makeFieldOptional("taxpayerId");
        } else if (isInvoice9x) {
            makeFieldOptional("customer");
            makeFieldRequired("taxpayerId");
            setValue("customer", null);
            setValue("country", { label: t("GR"), value: "GR", alpha2: "GR" });
            var branch = getValues().branch;
            setValue("loadingAddressStreet", branch.model.address);
        } else {
            makeFieldRequired("customer");
            makeFieldRequired("taxpayerId");
        }

        if (isZeroCustomerTIN) {
            setValue("taxpayerId", "000000000");
            disableField("taxpayerId");
        } else if (!isInvoice9x) {
            enableField("taxpayerId");
            enableField("customer");
        }

        if (mdit === "invoice5_1" || mdit === "invoice9_1" || isCredit) {
            disableCustomerFields();
        }

        // — address required fields: single authoritative pass —
        const isCountryDisable = Commons.isOnGroup(mdit, "countryDisable");
        const needsCity = isInvoice9x || mdit === "invoice3_1" || isCountryDisable || isDeliveryNoteChecked;
        const needsAddress = isInvoice9x || isDeliveryNoteChecked || mdit === "invoice1_2" || mdit === "invoice2_2";
        const needsPostal = isInvoice9x || mdit === "invoice2_1" || isCountryDisable || isDeliveryNoteChecked;
        const needsAddrNum = isInvoice9x || isDeliveryNoteChecked;

        needsCity ? makeFieldRequired("city") : makeFieldOptional("city");
        needsAddress ? makeFieldRequired("fulladdress") : makeFieldOptional("fulladdress");
        needsPostal ? makeFieldRequired("postalCode") : makeFieldOptional("postalCode");
        needsAddrNum ? makeFieldRequired("addressNumber") : makeFieldOptional("addressNumber");

        // — delivery mandatory: single authoritative pass —
        const deliveryMandatory = isInvoice9x || isDeliveryNoteChecked;
        setIsDeliverMandatory(deliveryMandatory);
        setIsLoadingMandatory(deliveryMandatory);
        setInitiallyCollapsedDeliveryMore({ collapsed: true, show: isInvoice9x });

        // — isDeliveryNote field enable/disable —
        isDeliveryNoteType ? enableField("isDeliveryNote") : disableField("isDeliveryNote");

        if (id == null) {
            if (!isCountryDisable) {
                setValue("country", DefaultCountry)
            }
            else {
                setValue("country", null)
            }
        }


        // — payment method —
        Commons.isOnGroup(mdit, "requiredPaymentMethod")
            ? makeFieldRequired("paymentMethod1")
            : makeFieldOptional("paymentMethod1");

        // — correlative sales —
        if (Commons.isOnGroup(mdit, "allowCorrelation")) show('correlativeSales');
        mdit === "invoice5_1" ? makeFieldRequired("correlativeSales") : makeFieldOptional("correlativeSales");

        // — UI panel visibility —
        Commons.isOnGroup(mdit, "trafficDataForbidden") ? hide('transformDataCard') : show('transformDataCard');
        mdit === "invoice9_2" ? show("connectedSales") : hide("connectedSales");
        setTransportInfoDisplay(["invoice2_01", "invoice11_02"].includes(mdit) ? "flex" : "none");
        setIsInvoice00_1(["invoice00_1", "invoice1_01"].includes(mdit));
        if (Commons.isOnGroup(mdit, "allowSelfPrice")) show('selfPricing');

        // — accordion visibility: resolve invoice8_2 and zeroPrice without conflict —
        if (isAccom) {
            hide('taxesMoreAccordion');
            hide('salesMoreAccordion');
        } else {
            show('taxesMoreAccordion');
            if (isZeroPrice) {
                setValue("paymentType", null);
                setValue("currency", null);
                setValue("exchangeRate", null);
                hide('salesMoreAccordion');
            } else {
                show('salesMoreAccordion');
            }
        }

        // — invoice8_2 accommodation entry —
        if (isAccom) {
            var saleEntry = {
                product: { id: undefined, label: t("AccomodationTax"), value: "AccomodationTax", model: { price: "0.00", priceWithVat: "0.00" } },
                measurementUnit: { label: "-", value: "-" },
                quantity: "-",
                vat: { label: "-", value: "VAT_EMPTY" },
                unitPrice: "0.00",
                priceWithVat: "0.00",
                priceWithoutVat: "0.00",
                unitPriceWithVat: "0.00",
                discount: "0.00",
            };
            refSalesEntries.current.setData([saleEntry]);
            setEntriesHidden("none");
            setOtherTaxHidden("flex");
            setOtherRequired(true);
        } else {
            setEntriesHidden("unset");
            setOtherTaxHidden("none");
            setOtherRequired(false);
        }

        // — classification categories API —
        var selfPricing = getValues().selfPricing;
        var asExpenses = Commons.isOnGroup(mdit, "isExpense") || selfPricing;

        ApiClient.getClassificationCategoriesOfMyDataInvoice(mdit, asExpenses).then(response => {
            var data = response.data;
            var _optionIncClassCategories = [];
            data.forEach(element => {
                var _classificationCategoryType = element.classificationCategory;
                var _classificationValueTypes = element.classificationValues;

                var prefix = _classificationCategoryType.replace("CATEGORY_", "") + ") ";
                _optionIncClassCategories.push({
                    value: _classificationCategoryType,
                    label: prefix + t(_classificationCategoryType),
                    classificationValues: _classificationValueTypes,
                    classificationValue: element.classificationValue,
                });
            });

            setSuggestedInClassCatsOfInvType(_optionIncClassCategories);
            setSuggestedInvoiceClassCatsOfInvType(val.invoiceTypeClassifications);
            if (isPreSale) {
                var sale = getValues();
                var saleEntries = refSalesEntries.current.getData();

                var saleObject = {
                    saleEntries: saleEntries.entries
                }
                if (saleEntries && saleEntries.entries.length > 0) {
                    setDataWithClassifications(saleObject, _optionIncClassCategories, sale.myDataMoreTaxes, true)
                }
            }
        },
            error => {
                console.error(
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString())
            }
        );

        // — series API —
        var branch = getValues().branch;
        var branchId = branch ? branch.model.id : null;
        if (branchId == null && val.branchId != null) {
            branchId = val.branchId;
        }
        setValue("series", "");
        setValue("invoiceNumber", "");
        ApiClient.getCompanyInvoiceTypeSeries(selectedCompany.id, invoiceTypeId, branchId, isCredit).then(response => {
            var data = response.data;
            var optionSeries = [];
            if (data) {
                data.forEach(element => {
                    optionSeries.push({
                        value: element.id,
                        startNumber: element.startNumber,
                        label: element.name,
                    });
                });
            }

            setContent(content => ({ ...content, series: optionSeries }));
            setBlockuiLoading(false);
            clearErrors("invoiceType");
            show('afterinvoice');

            if ((id == undefined || isCredit) && optionSeries.length > 0) {
                var defaultsSeriesLetters = optionSeries.map(c => c.label);

                if (defaults != undefined && defaults.series != undefined && defaults.series.__isNew__) {
                    setValue("series", defaults.series);
                    changeSeries(defaults.series);
                } else if (optionSeries.length == 1) {
                    setValue("series", optionSeries[0]);
                    changeSeries(optionSeries[0]);
                } else if (defaults.series && defaultsSeriesLetters.includes(defaults.series.label)) {
                    setValue("series", defaults.series);
                    changeSeries(defaults.series);
                }
            }

            let customer = params.get('customer');
            if (customer) {
                ApiClient.getCompanyCustomer(companyId, customer).then(
                    response => {
                        var cust = response.data;
                        var cust_obj = {
                            label: cust.name,
                            value: customer,
                            taxpayerId: cust.taxpayerId,
                            model: cust
                        };
                        setValue("customer", cust_obj);
                        setCustomerValue(cust_obj);
                        changeCust(cust_obj);
                    },
                    error => {
                        toast.error("Error: " + error.data);
                        console.error(error.data);
                    }
                );
            }
        },
            error => {
                setBlockuiLoading(false);
                console.error(
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString());
            }
        );

        if (id == undefined) {
            Commons.setDefault("invoiceType", val);
        }

        appendAccountantEmailOnContactsSelect();
    }

    function clearDeliveryValues() {
        setValue("loadingAddressStreet", null);
        setValue("loadingAddressNumber", null);
        setValue("loadingAddressCity", null);
        setValue("loadingAddressPostalCode", null);
        setValue("deliveryAddressStreet", null);
        setValue("deliveryAddressNumber", null);
        setValue("deliveryAddressCity", null);
        setValue("deliveryAddressPostalCode", null);
        setValue("movePurpose", null);
        setValue("isDeliveryNote", false);
    }

    const onChangeInvoiceType = val => {
        setValue("invoiceType", val)
        var defaults = Commons.getDefaults();

        if (defaults != undefined && defaults.series != undefined && defaults.series.__isNew__) {
            Commons.setDefault("series", null)
        }
        clearDeliveryValues();
        if (!isPreSale) {
            refSalesEntries.current.clearData();
        }

        if (content != undefined) {
            changeInvType(val)
        }
    };

    const onChangeConnectedInvoice = corVal => {
        setValue("connectedSales", corVal);

    };

    const onInputChangeConnectedInvoice = (val, action) => {
        // if (action.action != "input-blur" && action.action != "menu-close") {
        //     setValue("connectedSales", { label: val, value: val });
        // }
    };

    const onChangeCorrelativeInvoice = val => {
        setValue("correlativeSales", val, { shouldValidate: true });
        if (val.model) {
            var selfPricing = getValues().selfPricing;
            var asExpenses = Commons.isOnGroup(val.model.myDataInvoiceType, "isExpense") || selfPricing;
            var companyId = selectedCompany.id;

            ApiClient.getCompanyCustomerByTaxpayerId(companyId, val.model.customerTaxPayerId, val.model.customerName).then(
                response => {
                    var cust = response.data;
                    var cust_obj = {
                        label: cust.name,
                        value: cust.id,
                        taxpayerId: cust.taxpayerId,
                        model: cust
                    };
                    setValue("customer", cust_obj);
                    setCustomerValue(cust_obj);
                    changeCust(cust_obj);
                },
                error => {
                    console.error("Error: " + error.data)
                }
            );

            ApiClient.getClassificationCategoriesOfMyDataInvoice(val.model.myDataInvoiceType, asExpenses).then(response => {
                var data = response.data;
                var obj = {}
                data.forEach(element => {
                    obj[element.classificationCategory] = element.classificationValues;
                });
                var _selectedInvoiceType = getValues().invoiceType;

                if (_selectedInvoiceType.myDataInvoiceType != "invoice8_2") {
                    setDataWithClassifications(val.model, obj, moreTaxesOptions)
                    if (val.model.saleInstanceMoreTaxes && val.model.saleInstanceMoreTaxes.length > 0) {
                        val.model.saleInstanceMoreTaxes.forEach(tax => {
                            if (tax.deduction) {
                                tax.myDataMoreTax = tax.deduction;
                            }

                            tax.value = "TAX_" + tax.uid;
                            tax.label = tax.type == "DEDUCTION" ? tax.name : t("TAX_" + tax.uid);
                            tax.type = {
                                value: tax.myDataMoreTax.type,
                                label: t(tax.myDataMoreTax.type)
                            }

                            tax.myDataMoreTax.value = "TAX_" + tax.myDataMoreTax.uid;
                            tax.myDataMoreTax.label = t("TAX_" + tax.myDataMoreTax.uid);
                        });
                        var _data_transformed = saleMoreTaxesGridRef.current.transformData(val.model.saleInstanceMoreTaxes, moreTaxesTypesOptions, moreTaxesOptions)
                        saleMoreTaxesGridRef.current.setData(_data_transformed);
                        reCalculateTotals();
                        setInitiallyCollapsed({ collapsed: false, show: true });
                    }
                }
            },
                error => {
                    console.error(
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString())
                }
            );
        }

    }



    const convertPaymentTypes = types => {
        var optionspaymentTypes = [];
        if (types != undefined) {
            types.forEach(element => {
                optionspaymentTypes.push({
                    value: element.value,
                    label: t(element.label),
                });
            });

        }


        return optionspaymentTypes
    }

    const convertPaymentType = type => {
        var optionspaymentType = {
            value: type.value,
            label: t(type.label),
        }
        return optionspaymentType
    }


    const dismissSalesEditAlertHandle = () => {
        Commons.setDefault("dismissSalesEditAlert", true)
    }

    const parochosSuccessMessage = (message) => {
        return (
            <div>
                {message}<span style={{ marginLeft: 10 }}><button className="btn btn-skin btn-sm" onClick={e => { e.preventDefault(); e.stopPropagation(); navigate("/sales") }}> {t("here")} </button> </span>
            </div>
        )
    }


    const onChangeContact = data => {
        setSelectedContacts(data);
    };

    const onChangeDispatchDate = (date) => {
        setDispatchDate(date);
        setValue("dispatchDate", date);
    };

    const onChangeDate = (date) => {
        setStartDate(date);
        const athensDateTime = moment.tz(
            [date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes()],
            ATHENS_TIMEZONE
        );
        setValue("invoiceDate", athensDateTime.toDate());
    };

    const reCalculateTotals = () => {
        if (refSalesEntries.current) {
            var nodes = refSalesEntries.current.getData();
            var saletaxes = saleMoreTaxesGridRef.current.getData();
            refEntriesSummary.current.calculateAndUpdateUI(nodes, saletaxes);
        }
    }

    useChromeExtensionListener({ setValue, setCustomerValue, refSalesEntries, reCalculateTotals, t });

    const onClickFetchTaxPayerId = () => {
        var AFMcalledfor = getValues().taxpayerId;

        if (!AFMcalledfor) {
            toast.error(t("taxpayerIdRequired"));
            return;
        }

        var AFMcalledby = selectedCompany.taxpayerId;
        var username = selectedCompany.checkAfmUsername;
        var password = selectedCompany.checkAfmPassword

        setBlockuiLoading(true)

        var requestObject = {
            username: username,
            password: password,
            targetAfm: selectedCompany.taxpayerId,
            sourceAfm: AFMcalledfor,
        }



        ApiClient.checkAfmFromTaxis(requestObject).then(
            response => {
                try {
                    var res = response.data.Body.rgWsPublicAfmMethodResponse;

                    var error = res.pErrorRec_out;
                    if (error) {
                        if (error.errorCode != null) {
                            toast.error(error.errorDescr);
                            setBlockuiLoading(false)
                            return;
                        }
                    }


                    var basic_rec = res.RgWsPublicBasicRt_out;
                    var firm_act_tab = res.arrayOfRgWsPublicFirmActRt_out;
                    var _customerName = basic_rec.onomasia.substring(0, 127);
                    setValue("customer", { label: _customerName, value: _customerName });
                    setCustomerInputValue(_customerName)
                    setValue("fulladdress", basic_rec.postalAddress);
                    if (firm_act_tab) {
                        if (Array.isArray(firm_act_tab.RgWsPublicFirmActRtUser)) {
                            setValue("subjectField", firm_act_tab.RgWsPublicFirmActRtUser[0].firmActDescr);
                        }
                        else {
                            setValue("subjectField", firm_act_tab.RgWsPublicFirmActRtUser.firmActDescr);

                        }
                    }
                    setValue("country", DefaultCountry)
                    setValue("postalCode", basic_rec.postalZipCode);
                    setValue("city", basic_rec.postalAreaDescription);
                    setValue("addressNumber", basic_rec.postalAddressNo);
                    setValue("taxOffice", { "value": basic_rec.doy, "label": basic_rec.doyDescr });
                    setTaxOfficeValue({ "value": basic_rec.doy, "label": basic_rec.doyDescr });
                    var selectedMyDataInvType = getValues().invoiceType.myDataInvoiceType;
                    if (selectedMyDataInvType == "invoice2_01" || selectedMyDataInvType == "invoice11_02") {
                        setValue("recipientTaxPayerId", AFMcalledfor);
                        setValue("recipientName", _customerName);

                        setValue("senderTaxPayerId", AFMcalledfor);
                        setValue("senderName", _customerName);
                    }

                    show('saveCustomerForFuture');
                    trigger();
                    setBlockuiLoading(false)
                }
                catch (e) {
                    setBlockuiLoading(false)
                }

            },
            error => {
                if (error.response) {
                    toast.error(error.message + ": " + error.response.data.message)
                    console.error(error.response.data.message);
                }
                setBlockuiLoading(false)
            }
        )
    };

    const onChangeCurrency = (currency) => {
        setValue("currency", currency)
        setValue("exchangeRate", parseFloat(currency.rate).toFixed(4))
    };

    const onBalanceChange = (e) => {
        var newbalance = e.target.value ? e.target.value : 0.0;
        setValue("balance", parseFloat(newbalance).toFixed(2))
    };

    const onChangeSendAsPendingPayment = (e) => {
        // setValue("sendAsPendingPayment", e.target.value)
    }

    const onChangePreloadTransaction = (e) => {
        setValue("preloadTransaction", e.target.value)
    }

    const onChangePreloadExpiration = (e) => {
        setValue("preloadExpiration", e.target.value)
    }

    const onInputChangeContact = (contact) => {

    }

    const onFooterAddCustomer = () => {
        window.open("/customer", '_blank');

    }

    const cleanNotes = () => {
        setValue("notes", "");
    }

    const onOtherTaxesSelectChange = (val) => {
        clearErrors("otherTaxCategory");

        var rowData = refSalesEntries.current.getData();

        var newEntries = rowData.entries;
        var amount = getValues().otherTaxAmount;
        if (amount && amount != "") {
            var _amount = amount.toString().replace(",", ".");
            amount = parseFloat(_amount).toFixed(2);
        }
        newEntries[0].taxes = [{
            myDataMoreTax: val,
            myDataMoreTaxes: otherTaxesOptions,
            type: {
                value: "OTHER_TAXES",
                label: t("OTHER_TAXES")
            },
            amount: amount
        }];

        setValue("otherTaxCategory", val)
        reCalculateTotals()
        refSalesEntries.current.setData(newEntries)
    };

    const onOtherTaxAmountChange = (e) => {
        clearErrors("otherTaxAmount");

        var rowData = refSalesEntries.current.getData();
        var taxval = e.target.value.toString().replace(",", ".");

        var val = parseFloat(taxval).toFixed(2)

        var newEntries = rowData.entries;
        if (newEntries[0].taxes) {
            newEntries[0].taxes[0].amount = val
        }

        setValue("otherTaxAmount", val)
        reCalculateTotals()
        refSalesEntries.current.setData(newEntries)
    };

    const onCloseInvoiceTypeInfo = () => {
        var defaults = Commons.getDefaults();
        var invoice_type = getValues().invoiceType ? getValues().invoiceType.myDataInvoiceType : null;
        if (defaults && invoice_type) {
            var infos = defaults.invoiceTypeMessages;
            if (infos && infos.includes(invoice_type)) {
                var index = infos.indexOf(invoice_type);
                if (index !== -1) {
                    infos.splice(index, 1)
                    Commons.setDefault("invoiceTypeMessages", infos);
                }
            }
        }
    };

    const onSelectTemplateLanguage = (code) => {
        setSelectedTemplateLanguage(code);
        setValue("templateLang", code.toLowerCase(code));
        Commons.setDefault("templateLang", code.toLowerCase(code))
    };

    const onChangeSendAsPendingPaymentInCaseOfFailure = (code) => {
        // setValue("sendAsPendingPaymentInCaseOfFailure", code);
    };

    return (
        <FormProvider {...methods}>
            <SaleFormContext.Provider value={{ isFieldRequired, isFieldDisabled, isVisible }}>
                <form autoComplete="off" onSubmit={e => e.preventDefault()}>
                    <BlockUi loader={isPosPayment ? <PosLoader /> : <Loader active type='square-spin' />} tag="div" blocking={blockuiLoading}>
                        <div id="salesContainerParent" className="salesContainerParent">
                            <div className="alert alert-warning alert-dismissible fade show" role="alert" id="documentTypeInfo" style={{ display: isVisible('documentTypeInfo') ? 'block' : 'none' }}>
                                <div className="invoicetype_message" data="invoice2_1">{documentTypeInfoMessage}</div>
                                <button type="button" className="btn-close" data-bs-dismiss="alert" onClick={onCloseInvoiceTypeInfo} aria-label="Close"></button>
                            </div>

                            <div id="sales_form">
                                {/* <p className="skin" id="salesLeft">{t("salesLeftMess", { count: salesLeft })}</p> */}
                                <span id="salesLeft">
                                    <i className="fa fa-file-text-o" style={{ marginRight: 5, opacity: 0.8 }}></i>
                                    {t("salesLeftMess", { count: salesLeft })}
                                </span>

                                {sosMessage ? <div className={sosMessage.alertClass} role="alert" id="documentTypeInfo">
                                    <div className="sos_message">{sosMessage.message}</div>
                                </div> : <></>}


                                <FormLayout
                                    title={t('invoicePublice')}
                                // headerRightContent={
                                //     <p className="skin" id="salesLeft">{t("salesLeftMess", { count: salesLeft })}</p>

                                // }
                                >

                                    <div>
                                        <span>{editMark}</span>
                                        <InvoiceHeaderCard
                                            isFieldDisabled={isFieldDisabled}
                                            isFieldRequired={isFieldRequired}
                                            isVisible={isVisible}
                                            onChangeBranch={onChangeBranch}
                                            branches={content.optionBranches}
                                            onChangeInvoiceType={onChangeInvoiceType}
                                            invoiceTypes={content.optionsinvoiceTypes}
                                            onChangeCorrelativeInvoice={onChangeCorrelativeInvoice}
                                            onChangeConnectedInvoice={onChangeConnectedInvoice}
                                            onInputChangeConnectedInvoice={onInputChangeConnectedInvoice}
                                            loadPageOptions={loadPageOptions}
                                            selectedInvoiceDate={new Date(startDate)}
                                            maxInvoiceDate={moment.tz(ATHENS_TIMEZONE).add(1, 'days').toDate()}
                                            onChangeDate={onChangeDate}
                                            onChangeSeries={onChangeSeries}
                                            seriesOptions={content.series}
                                            isCredit={isCredit}
                                            isDeliveryNoteChange={isDeliveryNoteChange}
                                        />

                                        <CustomerCard
                                            customerCardRef={customerCardRef}
                                            isFieldRequired={isFieldRequired}
                                            isFieldDisabled={isFieldDisabled}
                                            isVisible={isVisible}
                                            onChangeCustomer={onChangeCustomer}
                                            inputCustomerValue={inputCustomerValue}
                                            onInputChangeCustomer={onInputChangeCustomer}
                                            customerValue={customerValue}
                                            loadCustomerPageOptions={loadCustomerPageOptions}
                                            onClickFetchTaxPayerId={onClickFetchTaxPayerId}
                                            noAfmCredentials={!selectedCompany?.checkAfmUsername || !selectedCompany?.checkAfmPassword}
                                            taxOfficeOnChange={taxOfficeOnChange}
                                            taxOfficeValue={taxOfficeValue}
                                            countryOnChange={countryOnChange}
                                            countryValue={countryValue}
                                            loadCountriesPageOptions={loadCountriesPageOptions}
                                            loadCurrenciesPageOptions={loadCurrenciesPageOptions}
                                            loadTaxOfficePageOptions={loadTaxOfficePageOptions}
                                            myDataInvoiceType={selectedMyDataInvoiceType}
                                        />

                                        <TransportSection
                                            transportInfoDisplay={transportInfoDisplay}
                                            isDeliverMandatory={isDeliverMandatory}
                                            isLoadingMandatory={isLoadingMandatory}
                                            dispatchDate={dispatchDate}
                                            dispatchStartDate={dispatchStartDate}
                                            onChangeDispatchDate={onChangeDispatchDate}
                                            onChangeMovePurpose={onChangeMovePurpose}
                                            isFieldRequired={isFieldRequired}
                                            initiallyCollapsedDeliveryMore={initiallyCollapsedDeliveryMore}
                                            isVisible={isVisible}
                                            movePurposes={content.movePurposes}
                                        />


                                        <div className="accordion sale-more-accordion" id="salesMoreAccordion" style={{ display: isVisible('salesMoreAccordion') ? 'unset' : 'none' }}>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="headingOne">
                                                    <a className="accordion-button collapsed nonhilight sale-more-accordion-btn" href="#" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                                                        <i className="fa fa-plus-circle" style={{ marginRight: 6 }}></i>{t("More")}
                                                    </a>
                                                </h2>
                                                <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#salesMoreAccordion">
                                                    <div className="accordion-body" style={{ padding: '8px 0 0 0' }}>
                                                        <div className="row">
                                                            <div className="col-md-9">
                                                                <div className="card sale-more-inner-card">
                                                                    <div className="row">

                                                                        <div className="col-md-4 selectInputContainer form-group">
                                                                            <label className="control-label inputlabel">{t('Currency')}</label>

                                                                            <Controller
                                                                                render={({ field, ref }) => (
                                                                                    <SelectTable {...field}
                                                                                        ref={ref}
                                                                                        inputId="country-react-select"
                                                                                        width={500}
                                                                                        onChange={onChangeCurrency}
                                                                                        onChangeValue={onChangeCurrency}
                                                                                        asyncPaginate={true}
                                                                                        isDisabled={isFieldDisabled("currency")}
                                                                                        columns={[{ header: t("Name"), hideHeader: true, field: "code", asLabel: true }]}
                                                                                        loadOptions={loadCurrenciesPageOptions}
                                                                                        t={t}
                                                                                        className={`form-control ${errors.country ? 'is-invalid' : ''}`}
                                                                                        placeholder={t('placeholderSelectCT')}
                                                                                    />
                                                                                )}
                                                                                control={control}
                                                                                rules={{ maxLength: 100 }}
                                                                                name="currency"
                                                                                defaultValue=""
                                                                            />

                                                                            <div className="invalid-feedback">{errors.currency?.message}</div>
                                                                        </div>
                                                                        <div className="col-md-4 form-group">
                                                                            <label className="control-label inputlabel">{t("ExchangeRate")}</label>
                                                                            <input
                                                                                name="exchangeRate"
                                                                                maxLength={20}
                                                                                {...register('exchangeRate', { maxLength: 20 })}
                                                                                className={`form-control ${errors.exchangeRate ? 'is-invalid' : ''}`}
                                                                            />
                                                                            <div className="invalid-feedback">{errors.exchangeRate?.message}</div>
                                                                        </div>
                                                                        <div className="col-md-4 form-group selfPricing" style={{ display: isVisible('selfPricing') ? 'unset' : 'none' }}>
                                                                            <div className="form-check d-flex align-items-center gap-2 mt-4">
                                                                                <input
                                                                                    id="selfPricingCheck"
                                                                                    name="selfPricing"
                                                                                    type="checkbox"
                                                                                    {...register('selfPricing', { required: false })}
                                                                                    onChange={onChangeSelfPricing}
                                                                                    className={`form-check-input ${errors.selfPricing ? 'is-invalid' : ''}`}
                                                                                />
                                                                                <label className="form-check-label inputlabel mb-0" htmlFor="selfPricingCheck">
                                                                                    {t("selfPricing")}
                                                                                    <Tippy trigger="click" content={<span className="tooltip-skin">{t("selfPricingInfo")}</span>}>
                                                                                        <i className="fa fa-x2 fa-info-circle infoicon"></i>
                                                                                    </Tippy>
                                                                                </label>
                                                                                <div className="invalid-feedback">{errors.selfPricing?.message}</div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {isPreSale ? <div className="alert alert-warning alert-dismissible fade show" role="alert">
                                            <div> {t("preSaleProductSuggestedClassificationsNotice")}</div>
                                        </div> : <></>}

                                        <div id="rounding-warning-portal"></div>
                                        <div className="sale_entries_row_container" style={{ display: entriesHidden }}>

                                            <SaleEntriesGrid ref={refSalesEntries}
                                                selectedInvoiceType={getValues().invoiceType}
                                                onChangeContact={onChangeContact}
                                                customerContacts={customerContacts}
                                                incomeClassCategories={suggestedInClassCatsOfInvType}
                                                invoiceClassCategories={suggestedInvoiceClassCatsOfInvType}
                                                vatCategoryExceptions={content.vatCategoryExceptions}
                                                otherTaxes={content.otherTaxes}
                                                withHoldTaxes={content.withHoldTaxes}
                                                measurementUnits={content.measurementUnits}
                                                selfPricing={selfPricingChecked}
                                                moreTaxesOptions={moreTaxesOptions}
                                                moreTaxesTypesOptions={moreTaxesTypesOptions}
                                                reCalculateTotals={reCalculateTotals}
                                                isInvoice00_1={isInvoice00_1}
                                                vats={content.vats}>

                                            </SaleEntriesGrid>
                                            <div className="text-center mobile-only" style={{ marginLeft: "42%", marginTop: 10 }}>
                                                <span className="scroll-sign">
                                                    <i className="fa fa-2x fa-angle-left"></i>
                                                    <i className="fa fa-2x fa-hand-o-up"> </i>
                                                    <i className="fa fa-2x fa-angle-right"></i>
                                                </span>
                                            </div>

                                        </div>

                                        <div className="card customerCard" style={{ display: otherTaxHidden }}>
                                            <div className="card-header">
                                                <i className="fa fa-calculator" style={{ marginRight: 6 }}></i>
                                                <span style={{ fontWeight: 600 }}>{t("taxInfo")}</span>
                                            </div>
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-md-4 selectInputContainer form-group required">
                                                        <label className="control-label inputlabel">{t("TaxType")} </label>
                                                        <Controller
                                                            render={({ field }) => (
                                                                <FormSelect
                                                                    field={field}
                                                                    onChange={onOtherTaxesSelectChange}
                                                                    inputId="otherTax-react-select"
                                                                    options={otherTaxesOptions}
                                                                    error={errors.otherTaxCategory}
                                                                    withMenu
                                                                />
                                                            )}
                                                            control={control}
                                                            name="otherTaxCategory"
                                                        />
                                                    </div>
                                                    <div className="col-md-4 form-group required">
                                                        <label className="control-label inputlabel">{t("amountAccomodationTax")} </label>
                                                        <input
                                                            name="otherTaxAmount"
                                                            type="text"
                                                            {...register('otherTaxAmount')}
                                                            onBlur={onOtherTaxAmountChange}
                                                            className={`form-control ${errors.otherTaxAmount ? 'is-invalid' : ''}`}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <hr className="my-3" />
                                        <div className="row">

                                            <div className="col-md-3">
                                                <div className="notes-card card">
                                                    <div className="card-body p-2">
                                                        <textarea
                                                            name="notes"
                                                            maxLength="400"
                                                            {...register('notes', { maxLength: 400 })}
                                                            autoComplete="off"
                                                            rows={4}
                                                            className={`form-control notes-textarea ${errors.notes ? 'is-invalid' : ''}`}
                                                            placeholder={t('Notes')}
                                                        />
                                                        <div className="invalid-feedback">{errors.notes?.message}</div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-6 form-group">
                                                <div className="card" id="taxesMoreAccordion" style={{ display: isVisible('taxesMoreAccordion') ? 'unset' : 'none' }}>
                                                    <div className="card-body p-0">
                                                        <MoreTaxesGrid
                                                            ref={saleMoreTaxesGridRef}
                                                            moreTaxesTypesOptions={moreTaxesTypesOptions}
                                                            moreTaxesOptions={moreTaxesOptions}
                                                            rowTotals={totals.totalWithoutVat}
                                                            reCalculateTotals={reCalculateTotals}
                                                        >
                                                        </MoreTaxesGrid>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3 selectInputContainer form-group">
                                                <EntriesSummary ref={refEntriesSummary} onUpdateComplete={onUpdateComplete}></EntriesSummary>
                                            </div>
                                        </div>

                                        <div className="row mt-3">

                                            <div className="col-md-3" >
                                                <label className="control-label inputlabel">
                                                    {t("customerContacts")}
                                                    <Tippy trigger="click" content={<span className="tooltip-skin">{t("ccInfo")}</span>}>
                                                        <i className="fa fa-x2 fa-info-circle infoicon"></i>
                                                    </Tippy>
                                                </label>

                                                <Controller
                                                    render={({ field, ref }) => (
                                                        <SelectTable {...field}
                                                            ref={ref}
                                                            onChange={onChangeContact}
                                                            onChangeValue={onChangeContact}
                                                            onInputChange={onInputChangeContact}
                                                            isMulti={true}
                                                            options={customerContacts}
                                                            createTable={true}
                                                            className={`form-control ${errors.customerContact ? 'is-invalid' : ''}`}
                                                            placeholder={t('Select')}
                                                        />
                                                    )}
                                                    control={control}
                                                    name="customerContacts"
                                                    defaultValue=""
                                                />
                                                <div className="invalid-feedback">{errors.customerContact?.message}</div>

                                            </div>


                                            <div className="col-md-6">
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <PaymentMethodCard
                                                            title="PaymentMethod1"
                                                            suffix=""
                                                            options={convertPaymentTypes(content.paymentTypes)}
                                                            isFieldDisabled={isFieldDisabled}
                                                            onChangeType={onChangePaymentType}
                                                            onBlurAmount={onPaymentAmountChange}
                                                            onChangePreload={onChangePreloadTransaction}
                                                            onBlurExpiration={onChangePreloadExpiration}
                                                            requiredKey="paymentMethod1"
                                                            headerRight={
                                                                <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => setShowSecondPayment(v => !v)}>
                                                                    <i className={`fa ${showSecondPayment ? 'fa-minus' : 'fa-plus'}`}></i>
                                                                </button>
                                                            }
                                                        />
                                                    </div>
                                                    {showSecondPayment && <div className="col-md-6">
                                                        <PaymentMethodCard
                                                            title="PaymentMethod2"
                                                            suffix="2"
                                                            options={convertPaymentTypes(content.paymentTypes)}
                                                            isFieldDisabled={isFieldDisabled}
                                                            onChangeType={onChangePaymentType2}
                                                            onBlurAmount={onPaymentAmount2Change}
                                                            onChangePreload={onChangeSendAsPendingPayment}
                                                            onBlurExpiration={onPaymentAmountChange}
                                                        />
                                                    </div>}
                                                </div>
                                                <div id="balance_container" className="form-group mt-2" style={{ display: isVisible('balance_container') ? 'unset' : 'none' }}>
                                                    <label className="control-label inputlabel">{t("PaidAmount")}</label>
                                                    <input
                                                        name="balance"
                                                        type="text"
                                                        {...register('balance')}
                                                        onBlur={e => onBalanceChange(e)}
                                                        className={`form-control ${errors.balance ? 'is-invalid' : ''}`}
                                                    />
                                                    <div className="invalid-feedback">{errors.balance?.message}</div>
                                                </div>
                                            </div>



                                            <div className="col-md-3 totalsparent" >


                                                <div className="contacts-options-group mt-2">
                                                    <div className="form-check">
                                                        <input
                                                            type="checkbox"
                                                            id="sendPaymentLinkCheck"
                                                            name="sendPaymentLink"
                                                            checked={sendPaymentLink}
                                                            onChange={e => setSendPaymentLink(e.target.checked)}
                                                            className="form-check-input"
                                                        />
                                                        <label className="form-check-label" htmlFor="sendPaymentLinkCheck">
                                                            {t("sendPaymentLink")}
                                                        </label>
                                                    </div>

                                                    <div className="d-flex align-items-center gap-2 mt-2">
                                                        <span className="contacts-option-label">{t("langTemplate")}</span>
                                                        <Controller
                                                            render={() => (
                                                                <ReactFlagsSelect
                                                                    width={100}
                                                                    alignOptionsToRight
                                                                    name="templateLang"
                                                                    selected={selectedTemplateLanguage}
                                                                    onSelect={onSelectTemplateLanguage}
                                                                    customLabels={{ GR: "GR", GB: "GB" }}
                                                                    countries={["GR", "GB"]}
                                                                    fullWidth={false}
                                                                />
                                                            )}
                                                            control={control}
                                                            name="templateLang"
                                                            defaultValue="GR"
                                                        />
                                                    </div>

                                                    {/* <div className="form-check mt-2">
                                                        <input
                                                            id="sendAsPendingCheck"
                                                            name="sendAsPendingPaymentInCaseOfFailure"
                                                            type="checkbox"
                                                            {...register('sendAsPendingPaymentInCaseOfFailure', { required: false })}
                                                            onChange={onChangeSendAsPendingPaymentInCaseOfFailure}
                                                            className={`form-check-input ${errors.sendAsPendingPaymentInCaseOfFailure ? 'is-invalid' : ''}`}
                                                        />
                                                        <label className="form-check-label" htmlFor="sendAsPendingCheck">
                                                            {t("SendAsPendingPaymentInCaseOfFailure")}
                                                        </label>
                                                        <div className="invalid-feedback">{errors.sendAsPendingPaymentInCaseOfFailure?.message}</div>
                                                    </div> */}
                                                </div>

                                            </div>

                                        </div>
                                        <IFramePrintTemplate style={{ width: 800, height: "297mm", left: -1000, top: 0, position: "fixed", zIndex: -100 }} extracss={template.css} template={template} ref={iframePrintTemplate} ></IFramePrintTemplate>
                                    </div>

                                </FormLayout>

                                <SaleFooter
                                    isInvoice00_1={isInvoice00_1}
                                    onSubmit={onSubmit}
                                    onSubmitDraft={onSubmitDraft}
                                    handlePrint={handlePrint}
                                    handlePrintAndSave={handlePrintAndSave}
                                    onError={onError}
                                    onChangeSendAsPendingPayment={onChangeSendAsPendingPayment}
                                />
                            </div>
                            <ErrorDetailsModal ref={refErrorDetailsModal}></ErrorDetailsModal>
                        </div>
                    </BlockUi>
                </form>
            </SaleFormContext.Provider>
        </FormProvider>
    );
}

export default SalesAddEdit;